import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import Breadcrumbs from '@mui/material/Breadcrumbs';

import classes from './BreadCrumb.module.css';

const BreadCrumb = props => {
  return (
    <div className={classes.breadCumbContainer}>
      <Breadcrumbs aria-label="breadcrumb" separator="›">
        <Link className={classes.link} to="/store">
          EduStore
        </Link>
        <Link
          className={classes.link}
          to={
            props.productType === 'book'
              ? '/store/books'
              : props.productType === 'course'
              ? '/store/courses'
              : props.productType === 'degree'
              ? '/store/degrees'
              : '/store/posgrados'
          }
        >
          {props.productType === 'book'
            ? 'Libros'
            : props.productType === 'course'
            ? 'Cursos'
            : props.productType === 'degree'
            ? 'Licenciaturas'
            : 'Posgrados'}
        </Link>
        <p color="text.primary">{props.productName}</p>
      </Breadcrumbs>
    </div>
  );
};

BreadCrumb.propTypes = {
  // eslint-disable-next-line react/require-default-props
  productType: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  productName: PropTypes.string
};

export default BreadCrumb;
